function $8ad6d5bbb35fd69b$var$t() {
    return $8ad6d5bbb35fd69b$var$t = Object.assign ? Object.assign.bind() : function(t) {
        for(var s = 1; s < arguments.length; s++){
            var e = arguments[s];
            for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t;
    }, $8ad6d5bbb35fd69b$var$t.apply(this, arguments);
}
var $8ad6d5bbb35fd69b$var$s = {
    strings: [
        "These are the default values...",
        "You know what you should do?",
        "Use your own!",
        "Have a great day!"
    ],
    stringsElement: null,
    typeSpeed: 0,
    startDelay: 0,
    backSpeed: 0,
    smartBackspace: !0,
    shuffle: !1,
    backDelay: 700,
    fadeOut: !1,
    fadeOutClass: "typed-fade-out",
    fadeOutDelay: 500,
    loop: !1,
    loopCount: Infinity,
    showCursor: !0,
    cursorChar: "|",
    autoInsertCss: !0,
    attr: null,
    bindInputFocusEvents: !1,
    contentType: "html",
    onBegin: function(t) {},
    onComplete: function(t) {},
    preStringTyped: function(t, s) {},
    onStringTyped: function(t, s) {},
    onLastStringBackspaced: function(t) {},
    onTypingPaused: function(t, s) {},
    onTypingResumed: function(t, s) {},
    onReset: function(t) {},
    onStop: function(t, s) {},
    onStart: function(t, s) {},
    onDestroy: function(t) {}
}, $8ad6d5bbb35fd69b$var$e = new /*#__PURE__*/ (function() {
    function e() {}
    var n = e.prototype;
    return n.load = function(e, n, i) {
        if (e.el = "string" == typeof i ? document.querySelector(i) : i, e.options = $8ad6d5bbb35fd69b$var$t({}, $8ad6d5bbb35fd69b$var$s, n), e.isInput = "input" === e.el.tagName.toLowerCase(), e.attr = e.options.attr, e.bindInputFocusEvents = e.options.bindInputFocusEvents, e.showCursor = !e.isInput && e.options.showCursor, e.cursorChar = e.options.cursorChar, e.cursorBlinking = !0, e.elContent = e.attr ? e.el.getAttribute(e.attr) : e.el.textContent, e.contentType = e.options.contentType, e.typeSpeed = e.options.typeSpeed, e.startDelay = e.options.startDelay, e.backSpeed = e.options.backSpeed, e.smartBackspace = e.options.smartBackspace, e.backDelay = e.options.backDelay, e.fadeOut = e.options.fadeOut, e.fadeOutClass = e.options.fadeOutClass, e.fadeOutDelay = e.options.fadeOutDelay, e.isPaused = !1, e.strings = e.options.strings.map(function(t) {
            return t.trim();
        }), e.stringsElement = "string" == typeof e.options.stringsElement ? document.querySelector(e.options.stringsElement) : e.options.stringsElement, e.stringsElement) {
            e.strings = [], e.stringsElement.style.cssText = "clip: rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;";
            var r = Array.prototype.slice.apply(e.stringsElement.children), o = r.length;
            if (o) for(var a = 0; a < o; a += 1)e.strings.push(r[a].innerHTML.trim());
        }
        for(var u in e.strPos = 0, e.currentElContent = this.getCurrentElContent(e), e.currentElContent && e.currentElContent.length > 0 && (e.strPos = e.currentElContent.length - 1, e.strings.unshift(e.currentElContent)), e.sequence = [], e.strings)e.sequence[u] = u;
        e.arrayPos = 0, e.stopNum = 0, e.loop = e.options.loop, e.loopCount = e.options.loopCount, e.curLoop = 0, e.shuffle = e.options.shuffle, e.pause = {
            status: !1,
            typewrite: !0,
            curString: "",
            curStrPos: 0
        }, e.typingComplete = !1, e.autoInsertCss = e.options.autoInsertCss, e.autoInsertCss && (this.appendCursorAnimationCss(e), this.appendFadeOutAnimationCss(e));
    }, n.getCurrentElContent = function(t) {
        return t.attr ? t.el.getAttribute(t.attr) : t.isInput ? t.el.value : "html" === t.contentType ? t.el.innerHTML : t.el.textContent;
    }, n.appendCursorAnimationCss = function(t) {
        var s = "data-typed-js-cursor-css";
        if (t.showCursor && !document.querySelector("[" + s + "]")) {
            var e = document.createElement("style");
            e.setAttribute(s, "true"), e.innerHTML = "\n        .typed-cursor{\n          opacity: 1;\n        }\n        .typed-cursor.typed-cursor--blink{\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      ", document.body.appendChild(e);
        }
    }, n.appendFadeOutAnimationCss = function(t) {
        var s = "data-typed-fadeout-js-css";
        if (t.fadeOut && !document.querySelector("[" + s + "]")) {
            var e = document.createElement("style");
            e.setAttribute(s, "true"), e.innerHTML = "\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n        }\n        .typed-cursor.typed-cursor--blink.typed-fade-out{\n          -webkit-animation: 0;\n          animation: 0;\n        }\n      ", document.body.appendChild(e);
        }
    }, e;
}()), $8ad6d5bbb35fd69b$var$n = new /*#__PURE__*/ (function() {
    function t() {}
    var s = t.prototype;
    return s.typeHtmlChars = function(t, s, e) {
        if ("html" !== e.contentType) return s;
        var n = t.substring(s).charAt(0);
        if ("<" === n || "&" === n) {
            var i;
            for(i = "<" === n ? ">" : ";"; t.substring(s + 1).charAt(0) !== i && !(1 + ++s > t.length););
            s++;
        }
        return s;
    }, s.backSpaceHtmlChars = function(t, s, e) {
        if ("html" !== e.contentType) return s;
        var n = t.substring(s).charAt(0);
        if (">" === n || ";" === n) {
            var i;
            for(i = ">" === n ? "<" : "&"; t.substring(s - 1).charAt(0) !== i && !(--s < 0););
            s--;
        }
        return s;
    }, t;
}()), $8ad6d5bbb35fd69b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function t(t, s) {
        $8ad6d5bbb35fd69b$var$e.load(this, s, t), this.begin();
    }
    var s = t.prototype;
    return s.toggle = function() {
        this.pause.status ? this.start() : this.stop();
    }, s.stop = function() {
        this.typingComplete || this.pause.status || (this.toggleBlinking(!0), this.pause.status = !0, this.options.onStop(this.arrayPos, this));
    }, s.start = function() {
        this.typingComplete || this.pause.status && (this.pause.status = !1, this.pause.typewrite ? this.typewrite(this.pause.curString, this.pause.curStrPos) : this.backspace(this.pause.curString, this.pause.curStrPos), this.options.onStart(this.arrayPos, this));
    }, s.destroy = function() {
        this.reset(!1), this.options.onDestroy(this);
    }, s.reset = function(t) {
        void 0 === t && (t = !0), clearInterval(this.timeout), this.replaceText(""), this.cursor && this.cursor.parentNode && (this.cursor.parentNode.removeChild(this.cursor), this.cursor = null), this.strPos = 0, this.arrayPos = 0, this.curLoop = 0, t && (this.insertCursor(), this.options.onReset(this), this.begin());
    }, s.begin = function() {
        var t = this;
        this.options.onBegin(this), this.typingComplete = !1, this.shuffleStringsIfNeeded(this), this.insertCursor(), this.bindInputFocusEvents && this.bindFocusEvents(), this.timeout = setTimeout(function() {
            0 === t.strPos ? t.typewrite(t.strings[t.sequence[t.arrayPos]], t.strPos) : t.backspace(t.strings[t.sequence[t.arrayPos]], t.strPos);
        }, this.startDelay);
    }, s.typewrite = function(t, s) {
        var e = this;
        this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor && this.cursor.classList.remove(this.fadeOutClass));
        var i = this.humanizer(this.typeSpeed), r = 1;
        !0 !== this.pause.status ? this.timeout = setTimeout(function() {
            s = $8ad6d5bbb35fd69b$var$n.typeHtmlChars(t, s, e);
            var i = 0, o = t.substring(s);
            if ("^" === o.charAt(0) && /^\^\d+/.test(o)) {
                var a = 1;
                a += (o = /\d+/.exec(o)[0]).length, i = parseInt(o), e.temporaryPause = !0, e.options.onTypingPaused(e.arrayPos, e), t = t.substring(0, s) + t.substring(s + a), e.toggleBlinking(!0);
            }
            if ("`" === o.charAt(0)) {
                for(; "`" !== t.substring(s + r).charAt(0) && (r++, !(s + r > t.length)););
                var u = t.substring(0, s), p = t.substring(u.length + 1, s + r), c = t.substring(s + r + 1);
                t = u + p + c, r--;
            }
            e.timeout = setTimeout(function() {
                e.toggleBlinking(!1), s >= t.length ? e.doneTyping(t, s) : e.keepTyping(t, s, r), e.temporaryPause && (e.temporaryPause = !1, e.options.onTypingResumed(e.arrayPos, e));
            }, i);
        }, i) : this.setPauseStatus(t, s, !0);
    }, s.keepTyping = function(t, s, e) {
        0 === s && (this.toggleBlinking(!1), this.options.preStringTyped(this.arrayPos, this));
        var n = t.substring(0, s += e);
        this.replaceText(n), this.typewrite(t, s);
    }, s.doneTyping = function(t, s) {
        var e = this;
        this.options.onStringTyped(this.arrayPos, this), this.toggleBlinking(!0), this.arrayPos === this.strings.length - 1 && (this.complete(), !1 === this.loop || this.curLoop === this.loopCount) || (this.timeout = setTimeout(function() {
            e.backspace(t, s);
        }, this.backDelay));
    }, s.backspace = function(t, s) {
        var e = this;
        if (!0 !== this.pause.status) {
            if (this.fadeOut) return this.initFadeOut();
            this.toggleBlinking(!1);
            var i = this.humanizer(this.backSpeed);
            this.timeout = setTimeout(function() {
                s = $8ad6d5bbb35fd69b$var$n.backSpaceHtmlChars(t, s, e);
                var i = t.substring(0, s);
                if (e.replaceText(i), e.smartBackspace) {
                    var r = e.strings[e.arrayPos + 1];
                    e.stopNum = r && i === r.substring(0, s) ? s : 0;
                }
                s > e.stopNum ? (s--, e.backspace(t, s)) : s <= e.stopNum && (e.arrayPos++, e.arrayPos === e.strings.length ? (e.arrayPos = 0, e.options.onLastStringBackspaced(), e.shuffleStringsIfNeeded(), e.begin()) : e.typewrite(e.strings[e.sequence[e.arrayPos]], s));
            }, i);
        } else this.setPauseStatus(t, s, !1);
    }, s.complete = function() {
        this.options.onComplete(this), this.loop ? this.curLoop++ : this.typingComplete = !0;
    }, s.setPauseStatus = function(t, s, e) {
        this.pause.typewrite = e, this.pause.curString = t, this.pause.curStrPos = s;
    }, s.toggleBlinking = function(t) {
        this.cursor && (this.pause.status || this.cursorBlinking !== t && (this.cursorBlinking = t, t ? this.cursor.classList.add("typed-cursor--blink") : this.cursor.classList.remove("typed-cursor--blink")));
    }, s.humanizer = function(t) {
        return Math.round(Math.random() * t / 2) + t;
    }, s.shuffleStringsIfNeeded = function() {
        this.shuffle && (this.sequence = this.sequence.sort(function() {
            return Math.random() - .5;
        }));
    }, s.initFadeOut = function() {
        var t = this;
        return this.el.className += " " + this.fadeOutClass, this.cursor && (this.cursor.className += " " + this.fadeOutClass), setTimeout(function() {
            t.arrayPos++, t.replaceText(""), t.strings.length > t.arrayPos ? t.typewrite(t.strings[t.sequence[t.arrayPos]], 0) : (t.typewrite(t.strings[0], 0), t.arrayPos = 0);
        }, this.fadeOutDelay);
    }, s.replaceText = function(t) {
        this.attr ? this.el.setAttribute(this.attr, t) : this.isInput ? this.el.value = t : "html" === this.contentType ? this.el.innerHTML = t : this.el.textContent = t;
    }, s.bindFocusEvents = function() {
        var t = this;
        this.isInput && (this.el.addEventListener("focus", function(s) {
            t.stop();
        }), this.el.addEventListener("blur", function(s) {
            t.el.value && 0 !== t.el.value.length || t.start();
        }));
    }, s.insertCursor = function() {
        this.showCursor && (this.cursor || (this.cursor = document.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.setAttribute("aria-hidden", !0), this.cursor.innerHTML = this.cursorChar, this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)));
    }, t;
}();


/**
 * ShuffleText is random text effect class for DOM Elements.<br />
 * ShuffleTextはDOMエレメント用ランダムテキストクラスです。
 * @author IKEDA Yasunobu
 * @since 2012-02-07
 */ class $6398793d3358b16b$export$2e2bcd8739ae039 {
    /**
     * @param element DOMエレメントです。
     */ constructor(element){
        /**
         * The string for random text.
         * ランダムテキストに用いる文字列です。
         * @type {string}
         * @default 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
         */ this.sourceRandomCharacter = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        /**
         * The string for effect space.<br />
         * 空白に用いる文字列です。
         * @default '-'
         */ this.emptyCharacter = "-";
        /**
         * The milli seconds of effect time.<br />
         * エフェクトの実行時間（ミリ秒）です。
         * @default 600
         */ this.duration = 600;
        this._isRunning = false;
        this._originalStr = "";
        this._originalLength = 0;
        this._timeCurrent = 0;
        this._timeStart = 0;
        this._randomIndex = [];
        this._element = null;
        this._requestAnimationFrameId = 0;
        this._element = element;
        this.setText(element.textContent ?? "");
    }
    /**
     * Set new strings. <br />
     * テキストを設定します。
     * @param text テキスト文字列です。
     */ setText(text) {
        this._originalStr = text;
        this._originalLength = text.length;
    }
    /**
     * It is running flag. <br />
     * 再生中かどうかを示すブール値です。
     * @returns {boolean}
     */ get isRunning() {
        return this._isRunning;
    }
    /**
     * Play effect. <br />
     * 再生を開始します。
     */ start() {
        this.stop();
        this._randomIndex = [];
        let str = "";
        for(let i = 0; i < this._originalLength; i++){
            let rate = i / this._originalLength;
            this._randomIndex[i] = Math.random() * (1 - rate) + rate;
            str += this.emptyCharacter;
        }
        this._timeStart = new Date().getTime();
        this._isRunning = true;
        this._requestAnimationFrameId = requestAnimationFrame(()=>{
            this._onInterval();
        });
        if (this._element) this._element.textContent = str;
    }
    /**
     * Stop effect.<br />
     * 停止します。
     */ stop() {
        this._isRunning = false;
        cancelAnimationFrame(this._requestAnimationFrameId);
    }
    /**
     * Dispose this instance.<br />
     * メモリ解放のためインスタンスを破棄します。
     */ dispose() {
        cancelAnimationFrame(this._requestAnimationFrameId);
        this._isRunning = false;
        this.duration = 0;
        this._originalStr = "";
        this._originalLength = 0;
        this._timeCurrent = 0;
        this._timeStart = 0;
        this._randomIndex = [];
        this._element = null;
        this._requestAnimationFrameId = 0;
    }
    /**
     * インターバルハンドラーです。
     */ _onInterval() {
        this._timeCurrent = new Date().getTime() - this._timeStart;
        const percent = this._timeCurrent / this.duration;
        let str = "";
        for(let i = 0; i < this._originalLength; i++){
            if (percent >= this._randomIndex[i]) str += this._originalStr.charAt(i);
            else if (percent < this._randomIndex[i] / 3) str += this.emptyCharacter;
            else str += this.sourceRandomCharacter.charAt(Math.floor(Math.random() * this.sourceRandomCharacter.length));
        }
        if (percent > 1) {
            str = this._originalStr;
            this._isRunning = false;
        }
        if (this._element) this._element.textContent = str;
        if (this._isRunning) this._requestAnimationFrameId = requestAnimationFrame(()=>{
            this._onInterval();
        });
    }
}


const $1a6cd9663479e45c$var$parent = document.querySelector(".pro-div-2");
var $1f9540dd37513961$exports = {};
$1f9540dd37513961$exports = import.meta.resolve("dL4vT");


var $d9f39dc5149ccec5$exports = {};
$d9f39dc5149ccec5$exports = import.meta.resolve("ibaNP");


var $8c789576bcfcb367$exports = {};
$8c789576bcfcb367$exports = import.meta.resolve("3w0ql");


var $0c0ead5ef054cb2a$exports = {};
$0c0ead5ef054cb2a$exports = import.meta.resolve("26IWT");


var $089629dcf2e01862$exports = {};
$089629dcf2e01862$exports = import.meta.resolve("dtccz");


var $af54453c8fbeea9c$exports = {};
$af54453c8fbeea9c$exports = import.meta.resolve("baJd9");


var $e274f32b6b92cbf0$exports = {};
$e274f32b6b92cbf0$exports = import.meta.resolve("eRhFd");


var $13e32ade812064e4$exports = {};
$13e32ade812064e4$exports = import.meta.resolve("j0o3u");


var $36d5cf9cd34b1ea8$exports = {};
$36d5cf9cd34b1ea8$exports = import.meta.resolve("keyPk");


var $6f4f8ed699fdd87d$exports = {};
$6f4f8ed699fdd87d$exports = import.meta.resolve("bWW2B");


const $1a6cd9663479e45c$var$data = [
    {
        title: "Lifein1",
        img: new URL($1f9540dd37513961$exports).href,
        desc: "Lifein1 is a visual reminder that time is finite. Every dot represents a single week of your life \u2014 lived, present, and yet to come. By turning time into something you can see, Lifein1 helps you reflect, refocus, and rethink how you spend the weeks you have left.",
        tools: [
            "REACT",
            "REACT-ROUTER",
            "JAVASCRIPT",
            "TAILWIND",
            "CSS"
        ],
        linkGithub: "https://github.com/surajmaru/Lifein1-weekstracker",
        linkLiveview: "https://lifein1.vercel.app/"
    },
    {
        title: "TimeW",
        img: new URL($d9f39dc5149ccec5$exports).href,
        desc: "TimeW is a minimal focus app that lives on your desktop, showing the current time, date, and motivational quotes to keep you locked in. Set a focus duration, hit the focus button, and let TimeW help you stay present, productive, and distraction-free.",
        tools: [
            "JAVASCRIPT",
            "REACT",
            "VITE",
            "CSS",
            "TAILWIND"
        ],
        linkGithub: "https://github.com/surajmaru/TimeW-Focus-app",
        linkLiveview: "https://timew.vercel.app/"
    },
    {
        title: "ASMR Typing",
        img: new URL($8c789576bcfcb367$exports).href,
        desc: "A cool and Aesthetic site where you can relax and test your typing skill with the soothing background music and vibe.",
        tools: [
            "JAVASCRIPT",
            "REACT",
            "VITE",
            "CSS",
            "TAILWIND"
        ],
        linkGithub: "https://github.com/surajmaru/Aesthetic-Typing-ASMR",
        linkLiveview: "https://asmr-typing.vercel.app/"
    },
    {
        title: "Reaction Time Checker",
        img: new URL($0c0ead5ef054cb2a$exports).href,
        desc: "A React app to check how fast your reaction is",
        tools: [
            "JAVASCRIPT",
            "REACT",
            "VITE",
            "TAILWIND"
        ],
        linkGithub: "https://github.com/surajmaru/reaction-time-react-game",
        linkLiveview: "https://reaction-time-react-game.vercel.app/"
    },
    {
        title: "Youtube Video/Audio Downloader",
        img: new URL($089629dcf2e01862$exports).href,
        desc: "A modern YouTube Video & Audio Downloader built with React and powered by yt-dlp, allowing users to download videos or extract high-quality audio with a fast, intuitive interface.",
        tools: [
            "JAVASCRIPT",
            "EXPRESS",
            "NODE.JS",
            "YT-DLP",
            "FFMPEG"
        ],
        linkGithub: "https://github.com/surajmaru/Youtube-Video-Audio-Downloader",
        linkLiveview: ""
    },
    {
        title: "Forkify Web App",
        img: new URL($af54453c8fbeea9c$exports).href,
        desc: "A JavaScript-powered recipe application featuring API-based search, bookmarking, and dynamic serving calculations.",
        tools: [
            "HTML",
            "SASS",
            "JAVASCRIPT",
            "API",
            "PARCEL"
        ],
        linkGithub: "https://github.com/surajmaru/forkify-app",
        linkLiveview: "https://forkify-suraj.vercel.app/"
    },
    {
        title: "Game Marketplace App",
        img: new URL($e274f32b6b92cbf0$exports).href,
        desc: "A modern Game Marketplace built with JavaScript, focused on performance, interactivity, and clean user experience.",
        tools: [
            "HTML",
            "SASS",
            "JAVASCRIPT",
            "PARCEL"
        ],
        linkGithub: "https://github.com/surajmaru/Game-Marketplace",
        linkLiveview: "https://suraj-gamestore.vercel.app/"
    },
    {
        title: "Mapty",
        img: new URL($13e32ade812064e4$exports).href,
        desc: "A workout tracker that uses geolocation and maps to log, display, and manage running and cycling activities.",
        tools: [
            "HTML",
            "CSS",
            "JAVASCRIPT",
            "GEOLOCATION",
            "LEAFLET"
        ],
        linkGithub: "https://github.com/surajmaru/Mapty-App-JS",
        linkLiveview: "https://mapty-app-suraj.vercel.app/"
    },
    {
        title: "Bankist App",
        img: new URL($36d5cf9cd34b1ea8$exports).href,
        desc: "A banking app that demonstrates account management, transfers, loans, and real-time balance updates.",
        tools: [
            "HTML",
            "CSS",
            "JAVASCRIPT",
            "LOCALSTORAGE",
            "TIMEOUTS"
        ],
        linkGithub: "https://github.com/surajmaru/Bankist-App-JS",
        linkLiveview: "https://bankist-app-suraj.vercel.app/"
    },
    {
        title: "Bankist Web",
        img: new URL($6f4f8ed699fdd87d$exports).href,
        desc: "A DOM-focused banking interface that demonstrates dynamic UI updates, event handling, and smooth user interactions using JavaScript.",
        tools: [
            "HTML",
            "CSS",
            "JAVASCRIPT",
            "BOUNDINGCLIENT"
        ],
        linkGithub: "https://github.com/surajmaru/Bankist-Website-JS",
        linkLiveview: "https://bankist-website-suraj.vercel.app/"
    }
];
var $f0f2f1bb874ce976$exports = {};
$f0f2f1bb874ce976$exports = import.meta.resolve("1FelN");


var $dfc3b1a6a12f7265$exports = {};
$dfc3b1a6a12f7265$exports = import.meta.resolve("c8SKB");


function $1a6cd9663479e45c$export$b3890eb0ae9dca99() {
    $1a6cd9663479e45c$var$data.forEach((data)=>{
        const html = `

<div class="reveal">
      <div class="pro-2 pro-1-1 web ">
        <p class="pro-title">${data.title}</p>
        <img draggable="false" class="pro-img" loading="lazy" decoding="async" src="${data.img}" >
        <p class="pro-desc">${data.desc}</p>

        <div class="pro-bottom">

          <div class="pro-items">
          ${data.tools.map((tool)=>`<p class="pro-item reveal2">${tool}</p>`).join("")}
          </div>
          
          <div class="footer-divider"></div>
          
          <div class="pro-footer reveal2">
            <a href="${data.linkGithub}" target="_blank">
              <div class="pro-footer1">
                <p >GITHUB</p> 
                <img class="pro-footer-github" src=${new URL($f0f2f1bb874ce976$exports).href}>
              </div>
            </a>
            ${data.linkLiveview ? `<a href="${data.linkLiveview}" target="_blank">
              <div class="pro-footer1">
                <p >LIVE VIEW</p> 
                <img class="pro-footer-github" src=${new URL($dfc3b1a6a12f7265$exports).href}>
              </div>
            </a>` : ""}
          </div>
        </div>
      </div>
      </div>

`;
        $1a6cd9663479e45c$var$parent.insertAdjacentHTML("beforeend", html);
    });
}


(0, $1a6cd9663479e45c$export$b3890eb0ae9dca99)();
const $efd3ba4ec2608b1d$var$btn = document.getElementById("themeToggle");
const $efd3ba4ec2608b1d$var$paragraphs = document.querySelectorAll("p");
const $efd3ba4ec2608b1d$var$sidebar = document.querySelectorAll(".sections");
const $efd3ba4ec2608b1d$var$sections = document.querySelectorAll("section");
const $efd3ba4ec2608b1d$var$skillCards = document.querySelectorAll(".skill-group1-1");
const $efd3ba4ec2608b1d$var$catBtn = document.querySelectorAll(".cat-p1");
const $efd3ba4ec2608b1d$var$cards = document.querySelectorAll(".pro-2");
//////////////////////////////////////////////////////////
// theme change
$efd3ba4ec2608b1d$var$btn.addEventListener("click", ()=>{
    document.body.classList.toggle("light-theme");
    if (document.body.classList.contains("light-theme")) {
        $efd3ba4ec2608b1d$var$paragraphs.forEach((p)=>p.style.color = "black");
        $efd3ba4ec2608b1d$var$btn.textContent = "\uD83C\uDF19";
    } else {
        $efd3ba4ec2608b1d$var$paragraphs.forEach((p)=>p.style.color = "");
        $efd3ba4ec2608b1d$var$btn.textContent = "\u2600\uFE0F";
    }
});
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////
// typing animation
const $efd3ba4ec2608b1d$var$typed = new (0, $8ad6d5bbb35fd69b$export$2e2bcd8739ae039)('#element', {
    strings: [
        "Hi, I'm Suraj Maru",
        'A Web Developer',
        'A Coder',
        'A YouTuber'
    ],
    typeSpeed: 100,
    backSpeed: 40,
    loop: true
});
/////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
// mouse movement animation
$efd3ba4ec2608b1d$var$skillCards.forEach((card)=>{
    card.addEventListener("mousemove", (e)=>{
        const rect = card.getBoundingClientRect();
        // console.log(e);
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.width / 2;
        const moveX = (x - centerX) / 15;
        const moveY = (y - centerY) / 15;
        card.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.03)`;
    });
    card.addEventListener("mouseleave", ()=>{
        card.style.transform = `translate(0,0) scale(1)`;
    });
});
/////////////////////////////////////////////////////////////
$efd3ba4ec2608b1d$var$catBtn.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        const category = btn.dataset.category;
        $efd3ba4ec2608b1d$var$catBtn.forEach((b)=>b.classList.remove("cat-active"));
        btn.classList.add("cat-active");
        let delay = 0;
        $efd3ba4ec2608b1d$var$cards.forEach((card)=>{
            const match = card.classList.contains(category);
            if (match) {
                card.classList.remove("removed");
                card.style.transitionDelay = `${delay}s`;
                requestAnimationFrame(()=>{
                    card.classList.remove("hidden");
                });
                delay += 0.08; // stagger effect
            } else {
                card.classList.add("hidden");
                card.classList.add("removed");
                card.style.transitionDelay = "0s";
            }
        });
    });
});
//////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////
// text effect
const $efd3ba4ec2608b1d$var$el = document.querySelector(".head-p");
if ($efd3ba4ec2608b1d$var$el) {
    const shuffle = new (0, $6398793d3358b16b$export$2e2bcd8739ae039)($efd3ba4ec2608b1d$var$el);
    $efd3ba4ec2608b1d$var$el.addEventListener("mouseenter", ()=>{
        // shuffle.setText("SURAJ MARU");
        shuffle.start();
    });
//   el.addEventListener("mouseleave", () => {
//   shuffle.stop();
// });
}
/////////////////////////////////////////////////////////////////////
// Live youtube stats display.
////////////////////////////////////////////////////////////////////
const $efd3ba4ec2608b1d$var$apiKey = 'AIzaSyAZ9MNp1bij-a4PWG8rhJ90QxiHfgBb3-I';
const $efd3ba4ec2608b1d$var$channelId = 'UCUDSEMu5pgsZqhUR27RBM8g';
const $efd3ba4ec2608b1d$var$videoIds = {
    airMouse: "xLPF6gYPwzA",
    jarvis: "GVieIRUcs5w"
};
async function $efd3ba4ec2608b1d$var$fetchSubscriberCount() {
    try {
        const response = await fetch(`https://www.googleapis.com/youtube/v3/channels?part=statistics&id=${$efd3ba4ec2608b1d$var$channelId}&key=${$efd3ba4ec2608b1d$var$apiKey}`);
        const data = await response.json();
        const stats = data.items[0].statistics;
        const subs = Number(stats.subscriberCount).toLocaleString();
        const videos = Number(stats.videoCount).toLocaleString();
        const views = Number(stats.viewCount).toLocaleString();
        document.getElementById('yt-subs').innerText = subs;
        document.getElementById('yt-videos').innerText = videos;
        document.getElementById('yt-views').innerText = views;
        /* ---------- VIDEO STATS ---------- */ const videoIdString = Object.values($efd3ba4ec2608b1d$var$videoIds).join(",");
        const videoRes = await fetch(`https://www.googleapis.com/youtube/v3/videos?part=statistics&id=${videoIdString}&key=${$efd3ba4ec2608b1d$var$apiKey}`);
        const videoData = await videoRes.json();
        videoData.items.forEach((video)=>{
            const views = Number(video.statistics.viewCount).toLocaleString();
            if (video.id === $efd3ba4ec2608b1d$var$videoIds.airMouse) document.getElementById("airmouse-views").innerText = views;
            if (video.id === $efd3ba4ec2608b1d$var$videoIds.jarvis) document.getElementById("jarvis-views").innerText = views;
        });
    } catch (error) {
        console.error('Error fetching subscriber count:', error);
    }
}
$efd3ba4ec2608b1d$var$fetchSubscriberCount();
setInterval($efd3ba4ec2608b1d$var$fetchSubscriberCount, 300000);
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
// button visibility depending on section
const $efd3ba4ec2608b1d$var$upArrow = document.querySelector(".up-arrow");
const $efd3ba4ec2608b1d$var$sectionHome = document.querySelector(".section-home");
function $efd3ba4ec2608b1d$var$handleHomeVisibility(entry) {
    if (entry.isIntersecting) $efd3ba4ec2608b1d$var$upArrow.classList.add("hidden");
    else $efd3ba4ec2608b1d$var$upArrow.classList.remove("hidden");
}
const $efd3ba4ec2608b1d$var$navHeight2 = $efd3ba4ec2608b1d$var$sectionHome.getBoundingClientRect().height;
const $efd3ba4ec2608b1d$var$observer2 = new IntersectionObserver(([entry])=>{
    $efd3ba4ec2608b1d$var$handleHomeVisibility(entry);
}, {
    root: null,
    threshold: 0
});
$efd3ba4ec2608b1d$var$observer2.observe($efd3ba4ec2608b1d$var$sectionHome);
// smooth scroll to top
$efd3ba4ec2608b1d$var$upArrow.addEventListener("click", function() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});
//////////////////////////////////////////////////////////////////////
// nav tap to scroll feature
$efd3ba4ec2608b1d$var$sidebar.forEach((ele)=>{
    const targetId = ele.dataset.target;
    const sectionn = document.getElementById(targetId);
    if (!sectionn) return;
    ele.addEventListener("click", function() {
        sectionn.scrollIntoView({
            behavior: 'smooth',
            block: "start"
        });
    });
});
// nav buttons dynamic change as per sections.
const $efd3ba4ec2608b1d$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        const id = entry.target.id;
        // console.log(id);
        const navItem = document.querySelector(`.sections[data-target="${id}"]`);
        if (!navItem) return;
        if (entry.isIntersecting) {
            $efd3ba4ec2608b1d$var$sidebar.forEach((item)=>item.classList.remove("cat-on"));
            navItem.classList.add("cat-on");
        }
    });
}, {
    root: null,
    threshold: 0.3
});
$efd3ba4ec2608b1d$var$sections.forEach((section)=>$efd3ba4ec2608b1d$var$observer.observe(section));
//////////////////////////////////////////////////////
const $efd3ba4ec2608b1d$var$c = document.getElementById("bg");
const $efd3ba4ec2608b1d$var$ctx = $efd3ba4ec2608b1d$var$c.getContext("2d");
function $efd3ba4ec2608b1d$var$resize() {
    $efd3ba4ec2608b1d$var$c.width = innerWidth;
    $efd3ba4ec2608b1d$var$c.height = innerHeight;
}
$efd3ba4ec2608b1d$var$resize();
addEventListener("resize", $efd3ba4ec2608b1d$var$resize);
const $efd3ba4ec2608b1d$var$mouse = {
    x: null,
    y: null,
    active: false
};
addEventListener("mousemove", (e)=>{
    $efd3ba4ec2608b1d$var$mouse.x = e.clientX;
    $efd3ba4ec2608b1d$var$mouse.y = e.clientY;
    $efd3ba4ec2608b1d$var$mouse.active = true;
});
addEventListener("mouseleave", ()=>{
    $efd3ba4ec2608b1d$var$mouse.active = false;
});
let $efd3ba4ec2608b1d$var$dots = Array.from({
    length: 80
}, ()=>({
        x: Math.random() * $efd3ba4ec2608b1d$var$c.width,
        y: Math.random() * $efd3ba4ec2608b1d$var$c.height,
        r: Math.random() * 3,
        dx: (Math.random() - 0.5) * 0.4,
        dy: (Math.random() - 0.5) * 0.4
    }));
function $efd3ba4ec2608b1d$var$animate() {
    $efd3ba4ec2608b1d$var$ctx.clearRect(0, 0, $efd3ba4ec2608b1d$var$c.width, $efd3ba4ec2608b1d$var$c.height);
    $efd3ba4ec2608b1d$var$ctx.fillStyle = "rgba(255,255,255,0.35)";
    $efd3ba4ec2608b1d$var$dots.forEach((d)=>{
        d.x += d.dx;
        d.y += d.dy;
        if ($efd3ba4ec2608b1d$var$mouse.active) {
            const distX = $efd3ba4ec2608b1d$var$mouse.x - d.x;
            const distY = $efd3ba4ec2608b1d$var$mouse.y - d.y;
            const distance = Math.sqrt(distX * distX + distY * distY);
            const maxDist = 150;
            if (distance < maxDist) {
                const force = (maxDist - distance) / maxDist;
                d.x += distX * force * 0.02;
                d.y += distY * force * 0.02;
            }
        }
        if (d.x < 0) d.x = $efd3ba4ec2608b1d$var$c.width;
        if (d.x > $efd3ba4ec2608b1d$var$c.width) d.x = 0;
        if (d.y < 0) d.y = $efd3ba4ec2608b1d$var$c.height;
        if (d.y > $efd3ba4ec2608b1d$var$c.height) d.y = 0;
        $efd3ba4ec2608b1d$var$ctx.beginPath();
        $efd3ba4ec2608b1d$var$ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        $efd3ba4ec2608b1d$var$ctx.fill();
    });
    requestAnimationFrame($efd3ba4ec2608b1d$var$animate);
}
$efd3ba4ec2608b1d$var$animate();
////////////////////////////////////////////
///////////////////////////////////////////
// sections reveal animations
const $efd3ba4ec2608b1d$var$reveals = document.querySelectorAll(".reveal, .reveal2");
// const reveals2 = document.querySelectorAll(".reveal2");
const $efd3ba4ec2608b1d$var$observerAnimation = new IntersectionObserver((entries, observer)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("show");
        else entry.target.classList.remove("show");
    });
}, {
    threshold: 0.15
});
window.addEventListener("load", ()=>{
    setTimeout(()=>{
        document.body.classList.add("ready");
        $efd3ba4ec2608b1d$var$reveals.forEach((el, i)=>$efd3ba4ec2608b1d$var$observerAnimation.observe(el));
    }, 800); // matches loader duration
});
// window.addEventListener("load", () => {
//   setTimeout(() => {
//     document.getElementById("intro")?.remove();
//   }, 2000);
// });
////////////////////////////////////////////////
const $efd3ba4ec2608b1d$var$footerYear = document.querySelector(".contact-footer-year");
$efd3ba4ec2608b1d$var$footerYear.textContent = new Date().getFullYear();


//# sourceMappingURL=path0.e7d5558f.js.map
